import { PropsWithChildren } from 'react';

const H2 = (props: PropsWithChildren<any>) => {
    const {
        className = '',
        ...otherProps
    } = props;
    return <h2 {...otherProps} className={`${className} ds-text-heading--2xl`}>{props.children}</h2>;
}
export default H2;